import React, { useState, useEffect } from "react";
import { Layout, Menu, Drawer, Button, Dropdown, Space, Badge } from "antd";
import { ShoppingCartOutlined, UserOutlined, MenuOutlined, DownOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useBasket } from "../components/BasketProvider";

const { Header: AntHeader } = Layout;

const Navbar = () => {
  const [visible, setVisible] = useState(false);
  const [currentContactIndex, setCurrentContactIndex] = useState(0);
  const contacts = ["📞 Call Us: +254729335354", "✉ Email: mwauraj118@gmail.com"];
  const { basket } = useBasket();

  const showDrawer = () => setVisible(true);
  const closeDrawer = () => setVisible(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentContactIndex((prevIndex) => (prevIndex + 1) % contacts.length);
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const languageMenu = (
    <Menu>
      <Menu.Item key="en">English</Menu.Item>
      <Menu.Item key="es">Spanish</Menu.Item>
      <Menu.Item key="fr">French</Menu.Item>
    </Menu>
  );

  const currencyMenu = (
    <Menu>
      <Menu.Item key="gbp">KSH.</Menu.Item>
    </Menu>
  );

  const headerStyle = {
    backgroundColor: "white",
    padding: "0 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  };

  const topBarStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#fff",
    fontSize: "12px",
    padding: "5px 20px",
    backgroundColor: "#000",
  };

  const contactStyle = {
    display: "flex",
    gap: "20px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const logoStyle = {
    height: "84px",
    objectFit: "contain",
    maxWidth: "100%",
  };

  const menuStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    listStyleType: "none",
    margin: 0,
    padding: 0,
    gap: "20px",
    fontSize: "18px",
    color: "black",
  };

  const drawerMenuStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "15px", // Spacing between links
  };
  
  const linkStyle = {
    textDecoration: "none",
    color: "#333", // Dark text color for readability
    fontSize: "16px",
    fontWeight: "500",
    transition: "color 0.3s ease", // Smooth color transition on hover
  };
  
  
  
  return (
    <Layout>
      {/* Top Bar */}
<div style={topBarStyle}>
  <div style={contactStyle}>
    <span>{contacts[currentContactIndex]}</span>
  </div>
  <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
    <Dropdown overlay={languageMenu} trigger={["hover"]}>
      <Space style={{ cursor: "pointer" }}>
        {/* Language Menu */}
      </Space>
    </Dropdown>
    <Dropdown overlay={currencyMenu} trigger={["hover"]}>
      <Space style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Kenya.svg/960px-Flag_of_Kenya.svg.png" 
          alt="Currency Icon" 
          style={{ width: "16px", height: "16px", marginRight: "5px" }} 
        />
        Currency <DownOutlined style={{ fontSize: "12px", color: "white" }} />
      </Space>
    </Dropdown>
  </div>
</div>


      {/* Main Navbar */}
      <AntHeader style={headerStyle}>
        {/* Left Section */}
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* Menu Icon for Mobile */}
          {window.innerWidth <= 768 && (
            <Button
              type="text"
              icon={<MenuOutlined style={{ color: "black", fontSize: "24px" }} />}
              onClick={showDrawer}
            />
          )}
          {/* Logo */}
          <Link to="/">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/got%2FGreen%20Professional%20Healthcare%20YouTube%20Thumbnail.png?alt=media&token=6a3647a0-a252-4de2-b990-a083941ba5c0"
              alt="Logo"
              style={logoStyle}
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <ul
          style={{
            ...menuStyle,
            display: window.innerWidth <= 768 ? "none" : "flex",
          }}
        >
          <li>
            <Link to="/" style={{ textDecoration: "none", color: "black" }}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/product" style={{ textDecoration: "none", color: "black" }}>
             All Products
            </Link>
          </li>
          <li>
            <Link to="/local" style={{ textDecoration: "none", color: "black" }}>
              Locally Made
            </Link>
          </li>
        
          <li>
            <Link to="/imports" style={{ textDecoration: "none", color: "black" }}>
              Orders & Imports
            </Link>
          </li>
          <li>
            <Link to="/discount" style={{ textDecoration: "none", color: "black" }}>
              Offers
            </Link>
          </li>
          <li>
            <Link to="/about" style={{ textDecoration: "none", color: "black" }}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/blog" style={{ textDecoration: "none", color: "black" }}>
              Blog
            </Link>
          </li>
          <li>
            <Link to="/contact" style={{ textDecoration: "none", color: "black" }}>
              Contact
            </Link>
          </li>
        </ul>

        {/* Right Icons */}
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <Link to="/basket">
            <Badge count={basket.length} offset={[5, 0]}>
              <ShoppingCartOutlined style={{ color: "black", fontSize: "28px" }} />
            </Badge>
          </Link>
          <Link to="/login">
            <UserOutlined style={{ color: "black", fontSize: "28px" }} />
          </Link>
        </div>
       
        <Drawer
      title={<span style={{ color: "#333", fontWeight: "bold" }}>Menu</span>}
      placement="left"
      onClose={closeDrawer}
      visible={visible}
      width={250}
      bodyStyle={{
        padding: "20px",
        backgroundColor: "#f7f7f7", // Light background color for the drawer body
      }}
      headerStyle={{
        backgroundColor: "#fff", // White background for the header
        borderBottom: "1px solid #e8e8e8", // Subtle border under the header
      }}
    >
      <div style={drawerMenuStyle}>
        <Link to="/product" style={linkStyle}>
          Home
        </Link>
        <Link to="/product" style={linkStyle}>
          All Products
        </Link>
        <Link to="/local" style={linkStyle}>
          Locally Made
        </Link>
        <Link to="/imports" style={linkStyle}>
          Orders & Imports
        </Link>
        <Link to="/discount" style={linkStyle}>
          Offers
        </Link>
        <Link to="/about" style={linkStyle}>
          About Us
        </Link>
        <Link to="/blog" style={linkStyle}>
          Blog
        </Link>
        <Link to="/contact" style={linkStyle}>
          Contact
        </Link>
      </div>
    </Drawer>
       
      </AntHeader>
    </Layout>
  );
};

export default Navbar;
